// primary-care-connect-main/frontend/src/pages/Portal/ClinicAdmin/Specialists/ManageSpecialistsPage.tsx

import React from "react";
import "../FamilyDoctors/ManageFamilyDoctorsPage.css"; // reuse table + modal + button styles (locked v1)

export default function ManageSpecialistsPage() {
  return (
    <div className="clinic-admin-providers">
      <header className="providers-header">
        <div>
          <h1>Specialists (V2)</h1>
          <p className="subtitle">
            This section is not available in Clinic Admin v1. It will be enabled in v2.
          </p>
        </div>
      </header>

      <div className="providers-table-wrapper">
        <div className="empty-state">
          Specialists management is coming in v2.
        </div>
      </div>
    </div>
  );
}
